import { history } from 'CustomHistory';
import { Events, Labels } from './constants';
import { v4 as uuidv4 } from 'uuid';
import isEmpty from 'lodash/isEmpty';

const fetchLocalUUID = () => {
  // eslint-disable-next-line no-undef
  let uuid = window.localStorage.getItem(process.env.REACT_APP_UUID_KEY);
  if (!uuid) {
    uuid = uuidv4();
    // eslint-disable-next-line no-undef
    window.localStorage.setItem(process.env.REACT_APP_UUID_KEY, uuid);
  }
  return uuid;
};
const isRemoteLogin = (user) => {
  return user?.device?.type === 'remote';
};
const getItem = async (key) => {
  let value = localStorage.getItem(key);
  if (window.isDesktop) {
    try {
      const desktopValue = await window.COM.invoke(Events.FETCH_DATA, { key });
      if (isEmpty(desktopValue) && !isEmpty(value)) {
        window.COM.send(Events.STORE_DATA, { key, value });
        return value;
      }
      value = desktopValue;
    } catch (e) {
      console.error(e);
    }
  }
  return value;
};

const setItem = (key, value) => {
  localStorage.setItem(key, value);
  if (window.isDesktop) {
    try {
      window.COM.send(Events.STORE_DATA, { key, value });
    } catch (e) {
      console.error(e);
    }
  }
};

const clearCache = async () => {
  const keysToRemove = [
    Labels.autoLogin,
    Labels.quickLogin,
    Labels.rememberLogin,
    Labels.user,
    Labels.userEmail
  ];

  for (const key of keysToRemove) {
    localStorage.removeItem(key);
    if (window.isDesktop) {
      try {
        window.COM.send(Events.REMOVE_DATA, { key });
      } catch (e) {
        console.error(e);
      }
    }
  }
  history.replace('/login');
};
const saveAutoLogin = async (enabled = true) => {
  localStorage.setItem(Labels.autoLogin, enabled ? 'true' : 'false');
  if (window.isDesktop) {
    try {
      window.COM.send(Events.STORE_DATA, {
        key: Labels.autoLogin,
        value: enabled ? 'true' : 'false'
      });
    } catch (e) {
      console.error(e);
    }
  }
};

const saveQuickLogin = async (enabled = true) => {
  localStorage.setItem(Labels.quickLogin, enabled ? 'true' : 'false');
  if (window.isDesktop) {
    try {
      window.COM.send(Events.STORE_DATA, {
        key: Labels.quickLogin,
        value: enabled ? 'true' : 'false'
      });
    } catch (e) {
      console.error(e);
    }
  }
};
const getAutoLogin = async () => await getItem(Labels.autoLogin);
const getRememberLogin = async () => await getItem(Labels.rememberLogin);
const getQuickLogin = async () => await getItem(Labels.quickLogin);
const fetchUser = async () => await getItem(Labels.user);
const fetchUserEmail = async () => await getItem(Labels.userEmail);
const clearUserEmail = async () => {
  localStorage.removeItem(Labels.userEmail);
  if (window.isDesktop) {
    try {
      window.COM.send(Events.REMOVE_DATA, { key: Labels.userEmail });
    } catch (e) {
      console.error(e);
    }
  }
};
const saveUserEmail = async (email) => {
  localStorage.setItem(Labels.userEmail, email);
  if (window.isDesktop) {
    try {
      window.COM.send(Events.STORE_DATA, {
        key: Labels.userEmail,
        value: email
      });
    } catch (e) {
      console.error(e);
    }
  }
};
const saveRememberLogin = async (user) => {
  localStorage.setItem(Labels.rememberLogin, 'true');
  localStorage.setItem(Labels.user, JSON.stringify(user));
  if (window.isDesktop) {
    try {
      window.COM.send(Events.STORE_DATA, {
        key: Labels.rememberLogin,
        value: 'true'
      });
      window.COM.send(Events.STORE_DATA, {
        key: Labels.user,
        value: JSON.stringify(user)
      });
    } catch (e) {
      console.error(e);
    }
  }

  // AsyncStorage.removeItem(Labels.timerStart);
  // AsyncStorage.removeItem(Labels.autoLogin);
};
const clearAutoLogin = async () => {
  localStorage.removeItem(Labels.autoLogin);
  if (window.isDesktop) {
    try {
      window.COM.send(Events.REMOVE_DATA, { key: Labels.autoLogin });
    } catch (e) {
      console.error(e);
    }
  }
};
const clearRememberLogin = async () => {
  localStorage.removeItem(Labels.rememberLogin);
  localStorage.removeItem(Labels.autoLogin);
  localStorage.removeItem(Labels.quickLogin);
  localStorage.removeItem(Labels.user);
  localStorage.removeItem(Labels.userEmail);
  if (window.isDesktop) {
    try {
      window.COM.send(Events.REMOVE_DATA, { key: Labels.rememberLogin });
      window.COM.send(Events.REMOVE_DATA, { key: Labels.user });
      window.COM.send(Events.REMOVE_DATA, { key: Labels.userEmail });
    } catch (e) {
      console.error(e);
    }
  }
};
const getUsername = (user) => {
  if (isRemoteLogin(user))
    return user.firstName + (user.lastName ? ` ${user.lastName}` : '');
  else return user.device?.name;
};
// TODO
const getTimeInMillis = (time, unit) => {
  if (unit) {
    return parseInt(unit, 10) === 1 ? time * 60 * 1000 : time * 60 * 60 * 1000;
  }

  return parseInt(time, 10) * 1000;
};
const formatNumbers = (numbers) => {
  return numbers.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  });
};
const getHours = (minutes) => {
  const x = parseInt(minutes) / 60;
  let h = Math.trunc(x);

  // let m = minutes % 60;
  // h = h < 10 ? `0${h}` : h;
  // m = m < 10 ? `0${m}` : m;

  return h;
};
const getMinutes = (minutes) => {
  // const x = minutes / 60;
  // let h = Math.trunc(x);
  let m = parseInt(minutes) % 60;

  // h = h < 10 ? `0${h}` : h;
  // m = m < 10 ? `0${m}` : m;

  return m;
};
const sleepModeShouldDisabled = (settings) => {
  const d = new Date();
  let n = d.getDay();

  n = n - 1;
  const key = `status_day_${n}`;

  if (key in settings) {
    return true;
  }

  return false;
};

const validate = (text) => {
  const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

  if (reg.test(text) === false) {
    return false;
  }

  return true;
};

/**
 * Checks if this login is live (in a Conference) on a different device
 *
 * @param {{ identifier: uuid, status: 'live' | 'away' | 'offline' }[]} status
 * Device status list from user.device.status
 * @returns {Boolean} True if another device is live with this login
 */
// eslint-disable-next-line no-unused-vars
const isConferenceLive = (status) => {
  // Removed to fix stale user.device.status state issue
  // TODO: Reimplement to enforce single device login again
  // let localuuid = fetchLocalUUID();
  // for (const item of status) {
  //   if (item.identifier !== localuuid && item.status === 'live') {
  //     return true;
  //   }
  // }
  return false;
};

export default {
  fetchLocalUUID,
  isRemoteLogin,
  getItem,
  setItem,
  clearCache,
  fetchUser,
  fetchUserEmail,
  saveUserEmail,
  clearUserEmail,
  saveAutoLogin,
  saveQuickLogin,
  getAutoLogin,
  getQuickLogin,
  getRememberLogin,
  getTimeInMillis,
  getUsername,
  saveRememberLogin,
  validate,
  getHours,
  getMinutes,
  formatNumbers,
  clearAutoLogin,
  clearRememberLogin,
  sleepModeShouldDisabled,
  isConferenceLive
};
